import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationExtras, Router } from '@angular/router';
import { NotificationService } from 'src/app/Service/notification.service';
import { GlobalConstants } from 'src/app/utils/global-constants';
import { Meta ,Title} from '@angular/platform-browser';

@Component({
    selector: 'app-families',
    templateUrl: './families.component.html',
    styleUrls: ['./families.component.css'],
    standalone: false
})
export class FamiliesComponent {
  emailForm:FormGroup;
  constructor( private router: Router,private notify:NotificationService,private formBuilder:FormBuilder,private meta:Meta,private title:Title ){
    this.title.setTitle("For Families | Family Central");
    this.meta.addTag({ name: 'description', content: 'Discover everything Family Central has to offer to help keep your organized and prepared with tools for suite of tools for financial planning, protecting vital documents, preserving family history, and more.' });
    this.emailForm = this.formBuilder.group({
      email: [
        '',
        [Validators.required, Validators.pattern(GlobalConstants.emailPattern)],
      ],
    });
  }
  goToOnboard() {
    if (this.emailForm.valid) {
      const navigationExtras: NavigationExtras = {
        state: {
          email: this.emailForm.get('email').value,
        },
      };
      this.router.navigateByUrl('/questionnaires', navigationExtras);
    } else {
      this.notify.showWarning('Please fill in the email field.');
    }
  }
}
